export default class DeleteForm {

    /**
     * Indica si el debug/log esta activo
     * @type {boolean}
     */
    debug = true;

    /**
     * Selector del formulario
     * @type {string}
     */
    formSelector ="model-form";

    /**
     * Selector de la accion guardar
     * @type {string}
     */
    buttonSelector= ".js-delete";

    /**
     * Url con la acction para borrar
     * @type {null}
     */
    restUrl= null;

    /**
     * Url del listado para redirigir despues de borrar
     * @type {null}
     */
    listUrl= null;

    /**
     * Logea, si esta activo, el mensaje
     * @param msg
     */
    log(msg){
        if(this.debug) {
            console.log("SaveForm: "+msg);
        }
    }

    get$Form() {
        if (this.$_form==null) {
            this.$_form=$(this.formSelector);
            console.log("form=" + this.formSelector);
        }
        return this.$_form;
    }

    async processDelete() {
        this.log("processDelete()");
        let me = this;

        if(confirm("¿Seguro que desea eliminar el elemento?")) {
            let $form = me.get$Form();

            $(me.buttonSelector).prop("disabled", true);
            let xhr = $.ajax(me.restUrl, {
                method: "post",
                data: {
                    op: "delete",
                    id: $form.find("input[name=id]").val(),
                    _token: $("meta[name=csrf-token]").attr("content")
                },
                dataType: "json",
                success: function (data) {
                    //console.log(data);
                    if (data.errorCode == 0) {
                        me.onDeleteSuccess();

                    } else {
                        me.showErrorMessage(data.errorMessages);
                    }
                },
                error: function (data) {
                    //console.log(data.responseText);
                    me.showErrorMessage();
                }
            });
        }
    }
    onDeleteSuccess() {
        this.log("onDeleteSuccess()");

        let url = this.listUrl;
        if (url.indexOf("?")===-1) {
            url+="?";
        }
        url+="&deleted=OK";
        window.actionClick = true;
        window.location.href = url;

    }
    showMessageWithModal(msg) {
        //swal(msg);
        alert(msg);
    }
    showErrorMessage(messages) {
        let $form = this.get$Form();
        $("#modal_cargando").remove();
        $(".modal-backdrop, .fade, .in").remove();
        console.log("showErrorMessage. Error sending message");
        let messageComplete = this.t("There was an error saving the form");
        console.log("messages=>");
        console.log(messages);
        if (messages==null) {
            messageComplete = "Error saving data";
            this.showMessageWithModal(this.t("Error al borrar los datos"));
        } else if (typeof messages == "string") {
            this.showMessageWithModal(messages);
        } else {

        }
    }
    initEvents() {
        $(this.buttonSelector).click(()=> {
            this.processDelete();
        })
    }
    t(s) {
        return s
    }
}